import styled from 'styled-components';

export const DummyInput = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
`;
